import React from 'react';
import {
  Button,
  IconArrow,
  IconAudioRecord,
} from 'gatorcomponents';
import * as S from './AiChatForm.styles';
import { AudioRecording } from '@/components/Layout/Menu/HeaderV2/AiChat/components/AudioRecording';

const AiChatForm = ({
  audioLocale,
  isAudioRecordingFeatureActive,
  handleStartRecording,
  handleStopRecording,
  loadingTranscription,
  onChange,
  onKeyDown,
  onSubmit,
  placeholder,
  recording,
  isRecording,
  value,
  disabled,
  testId = 'aichat-form',
}) => (
  <S.Wrapper $disabled={disabled}>
    <S.Form onSubmit={onSubmit} $disabled={disabled} id="aichat-form" data-testid={testId}>
      <S.TextArea
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        disabled={disabled}
        id="aichat-textarea"
        data-testid={`${testId}-textarea`}
      />
      {!isRecording && (
        <S.ActionsWrapper data-testid={`${testId}-actions-wrapper`}>
          {isAudioRecordingFeatureActive && (
            <S.ButtonRecordingAdapter onClick={handleStartRecording} disabled={disabled} data-testid={`${testId}-button-recording`}>
              <IconAudioRecord size="md" color={disabled ? 'highDark' : 'lowDark'} />
            </S.ButtonRecordingAdapter>
          )}
          <S.ButtonSubmitAdapter>
            <Button
              type="submit"
              variant="primary"
              width="fitContent"
              label={<IconArrow direction="top" />}
              disabled={!value || disabled}
              testId="submit"
            />
          </S.ButtonSubmitAdapter>
        </S.ActionsWrapper>
      )}
      {isRecording && (
        <AudioRecording
          onCancel={() => handleStopRecording({ cancelRecording: true })}
          onSend={() => handleStopRecording({ cancelRecording: false })}
          isRecording={recording}
          transcribing={loadingTranscription}
          locales={audioLocale}
        />
      )}
    </S.Form>
  </S.Wrapper>
);

export default AiChatForm;
